"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactts = exports.reactjs = void 0;
var spawn_1 = require("../../helpers/spawn");
var logger_1 = __importDefault(require("../../helpers/logger"));
var copy_templates_1 = __importDefault(require("../../helpers/copy-templates"));
var path_1 = require("path");
var uiAppDir = 'app-ui';
var log = logger_1.default('react-recipe');
var completeLogMsg = "\n  Your installation completed.\n  To start, run yarn tauri dev\n";
var afterCra = function () {
    copy_templates_1.default({
        source: path_1.resolve(__dirname, '../../templates/recipes/react/'),
        scope: {},
        target: path_1.join(uiAppDir, './src/')
    });
    log(completeLogMsg);
};
var reactjs = {
    descriptiveName: 'React.js',
    shortName: 'reactjs',
    configUpdate: function (cfg) { return (__assign(__assign({}, cfg), { distDir: "../" + uiAppDir + "/build", devPath: 'http://localhost:3000', beforeDevCommand: "yarn --cwd " + uiAppDir + " start", beforeBuildCommand: "yarn --cwd " + uiAppDir + " build" })); },
    extraNpmDevDependencies: ['create-react-app'],
    extraNpmDependencies: ['react'],
    postConfiguration: function (cwd) {
        spawn_1.spawnSync('yarn', ['create-react-app', uiAppDir], cwd);
        afterCra();
    }
};
exports.reactjs = reactjs;
var reactts = __assign(__assign({}, reactjs), { descriptiveName: 'React with Typescript', shortName: 'reactts', extraNpmDependencies: [
        'typescript',
        '@types/node',
        '@types/react',
        '@types/react-dom',
        '@types/jest'
    ], postConfiguration: function (cwd) {
        spawn_1.spawnSync('yarn', ['create-react-app', '--template', 'typescript', uiAppDir], cwd);
        afterCra();
    } });
exports.reactts = reactts;
